
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      dialog: false,
      text: "",
      mode: "refresh" as "refresh" | "settlement",
      openTimer: null as ReturnType<typeof setTimeout> | null,
      slowRequestTimer: null as ReturnType<typeof setTimeout> | null,
    };
  },
  methods: {
    setLoading(
      value: boolean,
      text = "",
      mode: "refresh" | "settlement" = "refresh",
      immediate = false
    ) {
      const OPEN_DELAY_MS = 150; // 빠른 처리 시 깜빡임 방지를 위한 열림 지연 시간 (ms)
      const SLOW_REQUEST_TIMEOUT_MS = 45000;

      if (value) {
        if (this.openTimer) clearTimeout(this.openTimer);
        this.text = text;
        this.mode = mode;

        if (immediate || this.dialog) {
          this.dialog = true;
        } else {
          this.openTimer = setTimeout(() => {
            this.dialog = true;
            this.openTimer = null;
          }, OPEN_DELAY_MS);
        }

        if (!this.slowRequestTimer) {
          this.slowRequestTimer = setTimeout(() => {
            this.slowRequestTimer = null;
            this.text =
              "조회할 데이터가 많아 시간이 걸리고 있습니다. 잠시만 기다려 주세요.";
          }, SLOW_REQUEST_TIMEOUT_MS);
        }
      } else {
        if (this.openTimer) {
          clearTimeout(this.openTimer);
          this.openTimer = null;
        }
        if (this.slowRequestTimer) {
          clearTimeout(this.slowRequestTimer);
          this.slowRequestTimer = null;
        }
        this.dialog = false;
      }
    },
  },
  beforeDestroy() {
    if (this.openTimer) clearTimeout(this.openTimer);
    if (this.slowRequestTimer) clearTimeout(this.slowRequestTimer);
  },
});
